import z from 'zod';

import { socialApiClient } from '@/shared/api-client/social-api-client';

export const discoverySessionSchema = z.object({
  session_id: z.string(),
  workspace_id: z.string(),
  current_search_history_id: z.string().nullable(),
  created_at: z.string(),
  updated_at: z.string(),
});

export type DiscoverySession = z.infer<typeof discoverySessionSchema>;

export async function getCurrentDiscoverySession(
  workspaceId: string,
  signal?: AbortSignal,
): Promise<DiscoverySession | null> {
  const response = await socialApiClient.get(`workspaces/${workspaceId}/discovery-session`, {
    signal,
  });

  if (response.status === 204) {
    return null;
  }

  return await response.json();
}
